import React from 'react';
import PropTypes from 'prop-types';

const StepMetadata = ({
  formData,
  updateFormData
}) => {
  return (
    <div className="wizard-step">
      <div className="step-intro">
        <h3>Prompt Metadata</h3>
        <p>Fill what you know. Leave blank to auto-generate with AI later.</p>
      </div>

      <div className="config-fields">
        <div className="form-group">
          <label htmlFor="description" className="form-label">
            Description
            <span className="label-optional">(Optional)</span>
          </label>
          <textarea
            id="description"
            value={formData.description}
            onChange={(e) => updateFormData('description', e.target.value)}
            placeholder="e.g., Generates professional emails to recipients based on role, topic, and tone..."
            className="form-textarea"
            rows={4}
          />
          <span className="field-hint">Detailed explanation of what this prompt does (2-3 sentences)</span>
        </div>

        <div className="form-group">
          <label htmlFor="use_case" className="form-label">
            Use Case
            <span className="label-optional">(Optional)</span>
          </label>
          <textarea
            id="use_case"
            value={formData.use_case}
            onChange={(e) => updateFormData('use_case', e.target.value)}
            placeholder="e.g., Email writing assistant for customer support teams"
            className="form-textarea"
            rows={4}
          />
          <span className="field-hint">What is this prompt for? (1-2 sentences)</span>
        </div>

        <div className="tip-box">
          <p className="tip-title">Tip</p>
          <p className="tip-content">
            Leave fields blank if you're unsure. On the final review step, you can use AI to
            auto-generate these based on your prompts.
          </p>
        </div>
      </div>
    </div>
  );
};

StepMetadata.propTypes = {
  formData: PropTypes.object.isRequired,
  updateFormData: PropTypes.func.isRequired,
};

export default StepMetadata;

